import s, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    background: #000;
  }
`;

export const DesktopWrap = s.section`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  background: #000;
  display: none;
  @media only screen and (min-width: 1000px) {
    display: flex;
  } 

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 4px;
    color: #fff;

    & > span {
      font-size: 15px;
      font-weight: 400;
      letter-spacing: 1px;
      text-transform: uppercase;
      padding-top: 32px;
      letter-spacing: 0.3px;
    }

    & > h2 {
      font-size: 32px;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: -1.28px;
    }

    & .bottomText {
      text-transform: none;
      padding-top: 0;
      letter-spacing: 0.6px;
    }
  }
`;

export const DesktopBWrap = s.section`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  background: #fff;
  display: none;
  @media only screen and (min-width: 1000px) {
    display: flex;
  } 

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 4px;
    color: #000;

    & > span {
      font-size: 15px;
      font-weight: 400;
      letter-spacing: 1px;
      text-transform: uppercase;
      padding-top: 32px;
      letter-spacing: 0.3px;
    }

    & > h2 {
      font-size: 32px;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: -1.28px;
    }

    & .bottomText {
      text-transform: none;
      padding-top: 0;
      letter-spacing: 0.6px;
    }

    & .logoContent {
      margin-top: 30px;
    }
  }
`;
